import { useEffect, useState } from "react";

const NAV_LINKS = [
  { id: "intro", label: "事件导读" },
  { id: "shimo", label: "来龙去脉" },
  { id: "timeline", label: "时间线" },
  { id: "check", label: "核实方法" },
  { id: "terms", label: "术语速查" },
  { id: "faq", label: "常见问题" },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 border-b border-background-200 shadow-none backdrop-blur"
          : "bg-transparent border-b border-white/10"
      }`}
    >
      <nav
        className={`flex items-center justify-between px-4 md:px-6 h-16 ${
          scrolled ? "text-foreground-950" : "text-background-50"
        }`}
        aria-label="主导航"
      >
        <a
          href="#hero"
          className="flex items-center gap-2 whitespace-nowrap group"
        >
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-lg font-label text-lg transition-colors ${
              scrolled
                ? "bg-primary-500 text-background-50"
                : "bg-background-50 text-primary-500"
            }`}
          >
            看
          </span>
          <span className="font-label text-xl tracking-wide leading-none">
            看料门专题
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-1">
          {NAV_LINKS.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className={`px-3 py-2 text-sm whitespace-nowrap rounded-md transition-colors hover:bg-white/10 ${
                  scrolled ? "hover:bg-secondary-100 text-foreground-700" : ""
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:block">
          <a
            href="#timeline"
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-primary-500 hover:bg-primary-100"
            }`}
          >
            一键看懂脉络
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md hover:bg-white/10"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl w-5 h-5 flex items-center justify-center`} />
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 text-foreground-950">
          <ul className="px-4 py-3 flex flex-col">
            {NAV_LINKS.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={() => setOpen(false)}
                  className="block px-2 py-2.5 text-sm border-b border-background-100 text-foreground-700 hover:text-primary-500"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="px-4 py-3">
            <a
              href="#timeline"
              onClick={() => setOpen(false)}
              className="flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-4 py-2.5 rounded-md text-sm"
            >
              一键看懂脉络
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}